import React, { useState, useEffect } from "react";

import MainContainer from "../MainContainer/MainContainer";

const StateProvider = () => {
  const [isAuthenticated, setAuthenticated] = useState(
    localStorage.getItem("isAuthenticated")
      ? JSON.parse(localStorage.getItem("isAuthenticated"))
      : ""
  );
  const [userRole, setUserRole] = useState(
    localStorage.getItem("userRole")
      ? JSON.parse(localStorage.getItem("userRole"))
      : ""
  );

  useEffect(() => {
    if (isAuthenticated) {
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("userRole", userRole.toString());
    } else if (!isAuthenticated) {
      localStorage.setItem("isAuthenticated", "");
      localStorage.setItem("userRole", "");
    }
  }, [isAuthenticated, userRole]);

  return (
    <MainContainer
      isAuthenticated={isAuthenticated}
      userRole={userRole}
      setAuthenticated={setAuthenticated}
      setUserRole={setUserRole}
    />
  );
};

export default StateProvider;
